import { AxiosPromise } from 'axios';
import { ActivateUserPayload, ResendActivationPayload, UserStatus } from '@dev/ee-api/ee-api-models';
import { request } from './request';

export const resetUserPassword = (sourceUrl: string, email: string): AxiosPromise<void> => {
    const { Users } = request();
    return Users.usersByUsernamePasswordGet(email, sourceUrl);
};

export const resendActivationEmailUser = (payload: ResendActivationPayload): AxiosPromise<void> => {
    const { Users } = request();
    return Users.usersActivationPost(payload);
};

export const setNewPasswordUser = (VerificationKey: string, Password: string): AxiosPromise<void> => {
    const { Users } = request();
    return Users.usersResetpasswordPut({ VerificationKey, Password });
};
export const activateUser = (activateNewUser: ActivateUserPayload): AxiosPromise<string> => {
    const { Users } = request();
    return Users.usersActivatePost(activateNewUser);
};

export const checkIfUserIsActivated = (username: string, verificationCode: string): AxiosPromise<UserStatus> => {
    const { Users } = request();
    return Users.usersCheckstatusByUsernameGet(username, verificationCode);
};
